import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the createDivisionModal state domain
 */

const selectCreateDivisionModalDomain = (state) =>
  state.get("createDivisionModal", initialState)

export const makeSelectDivisionsNoParent = () =>
  createSelector(selectCreateDivisionModalDomain, (state) =>
    state.get("divisionsNoParent")
  )

export const makeSelectIsLoadingCreate = () =>
  createSelector(selectCreateDivisionModalDomain, (state) =>
    state.get("isLoadingCreate")
  )

export const makeSelectReset = () =>
  createSelector(selectCreateDivisionModalDomain, (state) => state.get("reset"))

const makeSelectCreateDivisionModal = () =>
  createSelector(selectCreateDivisionModalDomain, (substate) => substate.toJS())

export default makeSelectCreateDivisionModal
export { selectCreateDivisionModalDomain }
